import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SubmitButton from '../_shared/SubmitButton';
import axios from 'axios';
import FormError from '../_shared/forms/FormError';
import FormInputNumber from '../_shared/forms/FormInputNumber';
import { snakeCaseToTitle } from '../../utils/Helpers';
import moment from 'moment';

const canvas = document.createElement('canvas');
const generateDummyImage = () => {
    canvas.width = 320;
    canvas.height = 200;
    const ctx = canvas.getContext('2d');

    // Fill background with white color
    ctx.fillStyle = '#CCCCCC';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw random shapes
    for (let i = 0; i < 10; i++) {
        ctx.fillStyle = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 50, 0, Math.PI * 2);
        ctx.fill();
    }

    return canvas.toDataURL('image/jpeg');
};

export default class TestingForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobId: '',
            errors: {},
        };
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            loading: false,
        });

        var token = localStorage.getItem('testing_app_token');
        if (!token) {
            toastr.error('Please log in');
            return;
        }

        if (this.validateForm() && token) {
            this.setState({
                loading: true,
            });

            var fakeData = new FormData();
            const currentDate = moment();
            const formatDate = (date) => date.format('YYYY-MM-DD'); // Format date as YYYY-MM-DD
            const formatDateTime = (date) => date.format('YYYY-MM-DD HH:mm:ss'); // Format date as YYYY-MM-DD HH:MM:SS

            fakeData.append('job_id', this.state.jobId);
            fakeData.append('after_loading_waste', formatDateTime(currentDate.clone().subtract(2, 'hours')));
            fakeData.append('appVersion', '1.0.0');
            fakeData.append('arm_chairs', 'false');
            fakeData.append('before_loading_waste', formatDateTime(currentDate.clone().subtract(5, 'hours')));
            fakeData.append('bin', 'true');
            fakeData.append('biodegradable_waste', '30');
            fakeData.append('car_battery', 'false');
            fakeData.append('car_tyres', 'false');
            fakeData.append('cardboard_paper', '5');
            fakeData.append('clearing_garage', 'true');
            fakeData.append('clearing_inside', 'true');
            fakeData.append('clearing_shed', 'true');
            fakeData.append('collection_date', formatDate(currentDate));
            fakeData.append('completion_time', formatDateTime(currentDate));
            fakeData.append('concrete_bricks', '20');
            fakeData.append('cooker', 'false');
            fakeData.append('customer_signature', generateDummyImage());
            fakeData.append('estimate_waste_removed', '90');
            fakeData.append('estimated_travel_time', '1');
            fakeData.append('fluorescent_tubes', 'false');
            fakeData.append('fridge_freezer', 'true');
            fakeData.append('gardening_note', 'Some gardening notes');
            fakeData.append('gardening', 'true');
            fakeData.append('gas_bottle', 'false');
            fakeData.append('glass', '2');
            fakeData.append('grass', 'true');
            fakeData.append('hedges', 'true');
            fakeData.append('images_after[]', generateDummyImage());
            fakeData.append('images_before[]', generateDummyImage());
            fakeData.append('job_complete', 'true');
            fakeData.append('job_notes', 'Some job notes');
            fakeData.append('large_domestic_appliances_(white_goods)', 'false');
            fakeData.append('location_lat', '51.091');
            fakeData.append('location_long', '-0.512');
            fakeData.append('loft', 'true');
            fakeData.append('mattress', 'false');
            fakeData.append('mixed_construction', '10');
            fakeData.append('mixed_metal', '50');
            fakeData.append('mixed_municipal', '15');
            fakeData.append('other_pops_waste', 'false');
            fakeData.append('other_work', 'Some other work');
            fakeData.append('paint_tins', 'false');
            fakeData.append('pc_base', 'false');
            fakeData.append('plastic', '5');
            fakeData.append('removing_greenhouse', 'true');
            fakeData.append('removing_shed', 'true');
            fakeData.append('route_arrived', formatDateTime(currentDate.clone().subtract(6, 'hours')));
            fakeData.append('route_started', formatDateTime(currentDate.clone().subtract(7, 'hours')));
            fakeData.append('second_member_id', '');
            fakeData.append('shrubs', 'true');
            fakeData.append('signature', generateDummyImage());
            fakeData.append('small_mixed_weee', 'false');
            fakeData.append('sofas', 'false');
            fakeData.append('time_after_loading', formatDateTime(currentDate.clone().subtract(2, 'hours')));
            fakeData.append('time_before_loading', formatDateTime(currentDate.clone().subtract(5, 'hours')));
            fakeData.append('time', formatDateTime(currentDate));
            fakeData.append('tip_off', '0');
            fakeData.append('total_waste_removed', '100');
            fakeData.append('trees', 'true');
            fakeData.append('tv_computer_monitor', 'false');
            fakeData.append('van_images_after[]', generateDummyImage());
            fakeData.append('van_images_before[]', generateDummyImage());
            fakeData.append('waste_cleared', 'true');
            fakeData.append('waste_collected', '45');
            fakeData.append('waste_contained', 'true');
            fakeData.append('waste_description', 'Mixed waste');
            fakeData.append('waste_volume', '50');
            fakeData.append('wood', '10');

            axios({
                url: this.props.url.replace('_job_', this.state.jobId),
                method: 'POST',
                data: fakeData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => {
                    toastr.success('Job updated successfully');

                    this.setState({
                        loading: false,
                    });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        toastr.error('Access denied, please log in again');
                    } else {
                        toastr.error('Job update failed');
                    }

                    this.setState({
                        loading: false,
                    });
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = ['jobId'];

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Complete job with fake data</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <FormInputNumber
                            classes="form-control"
                            label="Job Id"
                            handleChange={(e) => this.setState({ jobId: e.target.value })}
                        />
                        <FormError error={this.state.errors.jobId} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <SubmitButton buttonText={'Complete Job'} loading={this.state.loading} style={{ width: 200 }} />
                    </div>
                </div>
            </form>
        );
    }
}

if (document.getElementById('testing-form')) {
    let element = document.getElementById('testing-form');
    ReactDOM.render(<TestingForm url={element.dataset.url} />, element);
}
